export default {
  encode(str) {
    return str
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;');
  },
  decode(str) {
    return str
      .replaceAll('&lt;', '<')
      .replaceAll('&gt;', '>');
  },
};
